export default "__VITE_ASSET__hTdw1HJk__"